export default "__VITE_ASSET__g0Ts0vSX__"